import { useEffect, useMemo, useState } from "react";

/**
 * Client-side pagination helper.
 * Slices `items` into pages, clamps the current page when the list/size changes,
 * and resets to page 1 when the page size changes.
 */
export function usePagination(items, defaultSize = 50) {
  const list = useMemo(() => items || [], [items]);
  const [pageSize, setPageSize] = useState(defaultSize);
  const [page, setPage] = useState(1);

  const total = list.length;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => {
    if (page > pageCount) setPage(pageCount);
  }, [pageCount, page]);

  const start = (page - 1) * pageSize;
  const end = Math.min(start + pageSize, total);
  const pageItems = useMemo(() => list.slice(start, start + pageSize), [list, start, pageSize]);

  const changePageSize = (n) => {
    setPageSize(n);
    setPage(1);
  };

  return {
    page,
    setPage,
    pageSize,
    setPageSize: changePageSize,
    pageCount,
    total,
    pageItems,
    start,
    end,
  };
}
